<template>
  <div>
    <v-card
      elevation="1"
      class="card card-mobile"
      flat
      style="margin-left: 3rem; margin-right: 1rem; border-radius: 15px"
    >
      <v-system-bar height="60px" class="card-header-systembar">
        <label
          class="ml-5 my-5"
          style="color: #444444; font-size: 20px !important"
        >
          {{ $t("settingmaintenance") }}
        </label>
      </v-system-bar>
      <v-row>
        <v-col cols="12" xl="6" lg="6" md="12" sm="12">
          <v-row class="ml-5">
            <v-col cols="12" lg="6" md="6" xl="3" class="pr-1">
              <label
                class="mb-0"
                style="font-size: 15px; color: #424242; font-weight: bold"
                >{{ $t("startdatetime") }}</label
              >
              <v-menu
                v-model="frommenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="startdate"
                    prepend-inner-icon="mdi-calendar-blank-outline"
                    outlined
                    dense
                    readonly
                    v-bind="attrs"
                    placeholder="yyyy/mm/dd"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startdate"
                  @input="startdateDis()"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" lg="6" md="6" xl="3" class="pt-9 pr-1">
              <v-menu
                ref="timeMenu"
                v-model="timeMenu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="startTime"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    hide-details="auto"
                    id="time"
                    append-icon="mdi-clock-outline"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="timeMenu1"
                  v-model="startTime"
                  full-width
                  @input="$refs.timeMenu.save(startTime)"
                ></v-time-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" lg="6" md="6" xl="3" class="pr-1">
              <label
                class="mb-0"
                style="font-size: 15px; color: #47484b; font-weight: bold"
                >{{ $t("enddatetime") }}</label
              >
              <v-menu
                id="date_"
                v-model="tomenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="enddate"
                    prepend-inner-icon="mdi-calendar-blank-outline"
                    outlined
                    dense
                    placeholder="yyyy/mm/dd"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="enddate"
                  @input="tomenu = false"
                  :allowed-dates="allowedEndDates"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" lg="6" md="6" xl="3" class="pt-9 pr-1">
              <v-menu
                ref="timeMenu"
                v-model="timeMenu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="endTime"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    hide-details="auto"
                    id="time"
                    append-icon="mdi-clock-outline"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="timeMenu2"
                  v-model="endTime"
                  full-width
                  @input="$refs.timeMenu.save(endTime)"
                ></v-time-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row class="ml-5" md="5" lg="5" sm="5">
            <v-col style="max-width: 89%">
              <label for="location" class="font-style">
                {{ $t("title") }}
              </label>
              <v-text-field
                outlined
                dense
                hide-details="auto"
                id="location"
                v-model="title"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ml-5">
            <v-col style="max-width: 89%">
              <label for="location" class="font-style">
                {{ $t("row1") }}
              </label>
              <v-text-field
                outlined
                dense
                hide-details="auto"
                id="location"
                v-model="row1"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ml-5">
            <v-col style="max-width: 89%">
              <label for="location" class="font-style">
                {{ $t("row2") }}
              </label>
              <v-text-field
                outlined
                dense
                hide-details="auto"
                id="location"
                v-model="row2"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ml-5">
            <v-col style="max-width: 89%">
              <label for="location" class="font-style">
                {{ $t("row3") }}
              </label>
              <v-text-field
                outlined
                dense
                hide-details="auto"
                id="location"
                v-model="row3"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ml-5">
            <v-col style="max-width: 89%">
              <label for="location" class="font-style">
                {{ $t("lineid") }}
              </label>
              <v-text-field
                outlined
                dense
                hide-details="auto"
                id="location"
                v-model="line"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ml-5">
            <v-col style="max-width: 89%">
              <label for="location" class="font-style">
                {{ $t("facebook") }}
              </label>
              <v-text-field
                outlined
                dense
                hide-details="auto"
                id="location"
                v-model="facebook"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ml-5">
            <v-col style="max-width: 89%">
              <label for="location" class="font-style">
                {{ $t("email") }}
              </label>
              <v-text-field
                outlined
                dense
                hide-details="auto"
                v-model="email"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ml-5 mt-8">
            <label class="ml-5">Display</label>
            <v-row class="check">
              <div>
                <v-checkbox
                  v-model="customerweb"
                  label="Customer web"
                ></v-checkbox>
              </div>
              <div class="checkuser">
                <v-checkbox v-model="userview" label="User view"></v-checkbox>
              </div>
            </v-row>
          </v-row>
        </v-col>
        <v-col cols="12" xl="6" lg="6" md="12" sm="12">
          <v-row>
            <v-col class="pb-1">
              <label
                for="location"
                class="font-style mb-0"
                style="font-size: 15px; color: #47484b; font-weight: bold"
              >
                {{ $t("preview") }}
              </label>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div class="cardborder">
                <v-card class="bgpreview">
                  <div
                    style="
                      display: flex;
                      align-items: start !important;
                      position: absolute;
                      left: -2px;
                    "
                  >
                    <img
                      src="@/assets/imgs/SeedLogo.png"
                      class="seedLogo-size"
                      alt
                    />
                  </div>
                  <v-card
                    flat
                    id="my-card"
                    class="bgcenter"
                    style="background-color: transparent; box-shadow: unset"
                  >
                    <div class="content-container">
                      <v-row>
                        <v-col class="pb-0 row_flex">
                          <v-img
                            src="@/assets/imgs/yellow_alert.svg"
                            alt="Image Alt Text"
                            max-width="23"
                            max-height="23"
                            class="mr-1 icon-size"
                          ></v-img>
                          <label
                            class="pt-1 preview-title"
                            style="font-weight: bold"
                            >{{ preview_title }}</label
                          >
                          <v-img
                            src="@/assets/imgs/yellow_alert.svg"
                            alt="Image Alt Text"
                            max-width="23"
                            max-height="23"
                            class="ml-1 icon-size"
                          ></v-img>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          class="text-center pt-2 pb-0"
                          style="display: flex; justify-content: center"
                        >
                          <label class="mb-0 ml-3 mr-3 text_style">{{
                            preview_row1
                          }}</label>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          class="text-center pt-2 pb-0"
                          style="display: flex; justify-content: center"
                        >
                          <label class="mb-0 ml-3 mr-3 text_style">{{
                            preview_row2
                          }}</label>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          class="text-center pt-3 pb-0"
                          style="display: flex; justify-content: center"
                        >
                          <label class="mb-0 ml-3 mr-3 text_style">{{
                            preview_row3
                          }}</label>
                        </v-col>
                      </v-row>
                      <v-row sett class="ml-2 mr-1">
                        <v-col class="pb-0 row_flex">
                          <v-img
                            src="@/assets/imgs/lineimage.png"
                            alt="Image Alt Text"
                            class="icon-size-line"
                          ></v-img>
                          <label class="pt-1" style="font-size: 11px">{{
                            preview_lineId
                          }}</label>
                        </v-col>
                        <v-col class="row_flex pb-0">
                          <v-img
                            src="@/assets/imgs/fb.png"
                            alt="Image Alt Text"
                            class="icon-size"
                          ></v-img>
                          <label class="pt-1" style="font-size: 11px">{{
                            preview_fb
                          }}</label>
                        </v-col>

                        <v-col class="row_flex pb-0">
                          <v-img
                            src="@/assets/imgs/mail.png"
                            alt="Image Alt Text"
                            class="icon-size"
                          ></v-img>
                          <label class="pt-1" style="font-size: 11px">{{
                            preview_email
                          }}</label>
                        </v-col>
                      </v-row>
                      <v-spacer></v-spacer>
                    </div>
                    <img
                      src="@/assets/imgs/QR.png"
                      alt="QR Code"
                      class="qr_position"
                    />
                  </v-card>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          lg="12"
          xl="12"
          md="12"
          sm="12"
          style="
            justify-content: end;
            display: flex;
            padding-right: 2rem;
            padding-bottom: 1.5rem;
          "
        >
          <v-btn
            width="160"
            height="40"
            class="text-capitalize btn_hover_effect ml-5"
            style="
              color: #ffff;
              border: 1px solid #a6cc39;
              border-radius: 8px;
              font-size: 16px;
            "
            @click="UpdatePreview"
            color="#A6CC39"
            >{{ $t("updatepreview") }}</v-btn
          >
          <v-btn
            width="120"
            height="40"
            class="text-capitalize ml-5"
            style="
              color: #ffff;
              border: 1px solid #a6cc39;
              border-radius: 8px;
              font-size: 16px;
              margin-left: 37px;
            "
            @click="submit()"
            color="#A6CC39"
            >{{ $t("save") }}</v-btn
          >
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import * as moment from "moment/moment";
import enurl from "@/api/environment";
export default {
  name: "report",
  components: {},
  // computed: {
  //   startDateTimeRules() {
  //     return [(v) => !!v || "Specify start date time"];
  //   },
  //   endDateTimeRules() {
  //     return [(v) => !!v || "Specify end date time"];
  //   },
  //   titleRules() {
  //     return [(v) => !!v || "Title is required"];
  //   },
  //   row1Rules() {
  //     return [(v) => !!v || "Specify end time"];
  //   },
  //   row2Rules() {
  //     return [(v) => !!v || "Specify end time"];
  //   },
  //   row3Rules() {
  //     return [(v) => !!v || "Specify end time"];
  //   },
  //   wordContentRules() {
  //     return [(v) => !!v || "Word Content is required"];
  //   },
  // },
  data() {
    return {
      maintenanceID: 0,
      preview_title: "",
      preview_row1: "",
      preview_row2: "",
      preview_row3: "",
      preview_lineId: "",
      preview_fb: "",
      preview_email: "",
      url: enurl.apiUrl,
      createdBy: "admin",
      previewImage: "",
      imgurl: "",
      title: "",
      row1: "",
      row2: "",
      row3: "",
      line: "",
      facebook: "",
      email: "",
      frommenu: false,
      tomenu: false,
      customerweb: false,
      userview: false,
      enddate: "",
      startdate: "",
      timeMenu2: false,
      timeMenu1: false,
      startTime: "",
      endTime: ""
    };
  },
  watch: {},
  mounted() {
    this.getSettingMaintenance();
  },
  methods: {
    startdateDis() {
      let that = this;
      // @input="frommenu = false"
      that.frommenu = false;
      if (that.startdate > that.enddate) {
        that.enddate = that.startdate;
      }
    },
    allowedEndDates(val) {
      return val >= this.startdate;
    },
    checkData() {
      if (
        this.title === null ||
        this.title === "" ||
        this.row1 === null ||
        this.row1 === "" ||
        this.row2 === null ||
        this.row2 === "" ||
        this.row3 === null ||
        this.row3 === "" ||
        this.line === null ||
        this.line === "" ||
        this.facebook === null ||
        this.facebook === "" ||
        this.email === null ||
        this.email === "" ||
        this.endTime === null ||
        this.endTime === "" ||
        this.startTime === null ||
        this.startTime === "" ||
        this.enddate === null ||
        this.enddate === "" ||
        this.startdate === null ||
        this.startdate === ""
      ) {
        alert("Please fill out all data!");
        return false;
      } else {
        return true;
      }
    },
    async submit() {
      let self = this;
      let check = self.checkData();

      if (!check) {
        return false;
      }
      const startdata = new Date(self.startdate + "T" + self.startTime + ":00");
      const startisodata = startdata.toISOString();

      const enddata = new Date(self.enddate + "T" + self.endTime + ":00");
      const endisodata = enddata.toISOString();
      const data = {
        id: self.maintenanceID,
        createdBy: self.createdBy,
        title: self.title,
        messageOne: self.row1,
        messageTwo: self.row2,
        messageThree: self.row3,
        lineID: self.line,
        facebook: self.facebook,
        email: self.email,
        startDate: self.startdate,
        startTime: self.newformatDate(startisodata),
        endDate: self.enddate,
        endTime: self.newformatDate(endisodata),
        previewImage: null, //self.previewImage,
        customerWebFlag: self.customerweb,
        userviewWebFlag: self.userview
      };
      console.log("data", data);
      console.log("data", data);

      await axios
        .post(
          `${self.url}SettingMaintenance/AddOrUpdateSettingMaintenanceMessage`,
          data
        )
        .then(function(res) {
          if (res.data.status == 0) {
            self.getSettingMaintenance();
            alert("Data save successfully.");
          } else {
            alert(res.data.message);
          }
        })
        .catch(function(err) {
          alert(err);
        });
    },
    async getSettingMaintenance() {
      let that = this;
      await axios
        .get(
          `${that.url}SettingMaintenance/GetSettingMaintenanceMessage?companyID=null`
        )
        .then(function(response) {
          console.log(response.data);
          if (response.data.status == 0) {
            let temp = response.data.data;
            if (temp != null) {
              that.maintenanceID = temp.id;
              that.title = temp.title;
              that.row1 = temp.messageOne;
              that.row2 = temp.messageTwo;
              that.row3 = temp.messageThree;
              that.line = temp.lineID;
              that.facebook = temp.facebook;
              that.email = temp.email;
              that.startdate = temp.startDate.substring(0, 10);
              that.startTime = that.changeTimeFormat(temp.startTime);
              that.enddate = temp.endDate.substring(0, 10);
              that.endTime = that.changeTimeFormat(temp.endTime);
              that.customerweb = temp.customerWebFlag;
              that.userview = temp.userviewWebFlag;
              that.UpdatePreview();
            } else {
              that.showDefaultText();
            }
          }
        })
        .catch(function(err) {
          throw err;
        });
    },
    changeTimeFormat(time) {
      let temp_time = moment(time)
        .local()
        .format("DD/MM/YYYY  LT");
      let newstarttime = temp_time.split(" ");
      let startTime = newstarttime[2];
      let resStartTime = null;
      if (newstarttime[3] == "PM") {
        let separatetime = parseInt(startTime.split(":")[0]);
        let addtime = separatetime == 12 ? separatetime : separatetime + 12;
        resStartTime = addtime + ":" + startTime.split(":")[1];
      } else {
        if (startTime.split(":")[0] <= 9) {
          resStartTime =
            0 + startTime.split(":")[0] + ":" + startTime.split(":")[1];
        } else {
          resStartTime = startTime;
        }
      }
      return resStartTime;
    },
    newformatDate(newdate) {
      const newdate1 = newdate.split("T");
      const newtime = newdate1[1].split(":");
      const [year, month, day] = newdate1[0].split("-");
      const returndate =
        `${day}/${month}/${year}` + " " + newtime[0] + ":" + newtime[1] + ":00";
      return returndate;
    },
    UpdatePreview() {
      this.preview_title = this.title != "" ? this.title : this.preview_title;
      this.preview_row1 = this.row1 != "" ? this.row1 : this.preview_row1;
      this.preview_row2 = this.row2 != "" ? this.row2 : this.preview_row2;
      this.preview_row3 = this.row3 != "" ? this.row3 : this.preview_row3;
      this.preview_lineId = this.line != "" ? this.line : this.preview_lineId;
      this.preview_fb = this.facebook != "" ? this.facebook : this.preview_fb;
      this.preview_email = this.email != "" ? this.email : this.preview_email;
    },
    showDefaultText() {
      this.preview_title = "Seedkm ปิดปรับปรุงเว็บไซต์";
      this.preview_row1 = "ในวันอังคารที่ 11 เมษายน 2566 เวลา 18:00 - 22:00 น.";
      this.preview_row2 =
        "เพื่อเพิ่มประสิทธิภาพในการให้บริการที่ดียิ่งยึ้น และอเปิดให้ใช้งานได้อีกครั้ง ตั้งแต่เวลา 23:00 นเป็นต้นไป";
      this.preview_row3 =
        "ขออภัยในความไม่สะควกมา ณ ที่นี้ หากพบปัญหาโปรคติดต่อ ทีม Support ได้ที่";
      this.preview_lineId = "@seed-km";
      this.preview_fb = "seed-km";
      this.preview_email = "seed@fusionsol.com";
    }
  }
};
</script>
<style scoped lang="scss">
.cardcenter {
  width: 95%;
  height: 319px;
  margin-top: -2%;
  background-color: transparent;
}
.cardborder {
  border: 10px dashed #9695956b;
  border-radius: 8px;
  width: 97%;
  height: 425px;
  padding: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bgpreview {
  background: url("~@/assets/imgs/leavesBg.png") center/cover;
  background-size: cover;
  object-fit: contain;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
<style scoped>
.bgcenter {
  background: url("~@/assets/imgs/maintenance_bg.svg") center/contain;
  width: 500px;
  height: 600px;
  padding: 0px;
  overflow: hidden !important;
  background-repeat: no-repeat;
  margin-left: 2rem;
}
.row_flex {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.text_style {
  /* white-space: nowrap; */
  width: 420px;
  font-size: 11px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical;
}
.content-container {
  position: absolute;
  top: 28%;
  left: 0;
  width: 90%;
  height: auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
::v-deep .check {
  margin-left: 15px;
  margin-top: -23px;
}
::v-deep .checkuser {
  margin-left: 15px;
}
.qr_position {
  width: 65px;
  height: 57px;
  position: absolute;
  bottom: 45px;
  right: 50px;
}
.preview-title {
  font-size: 15px;
}
.icon-size {
  max-width: 24px;
  max-height: 24px;
}
.icon-size-line {
  max-width: 26px;
  max-height: 26px;
}
.seedLogo-size {
  width: 100px;
  height: 100px;
  margin-top: -0.3rem;
}
</style>
<style scoped>
@media screen and (min-width: 1024px) and (max-width: 1400px) {
  .seedLogo-size {
    width: 85px;
    height: 85px;
    margin-top: -0.3rem;
  }
  .icon-size {
    margin-top: 5px;
    max-width: 18px;
    max-height: 18px;
  }
  .icon-size-line {
    max-width: 25px;
    max-height: 25px;
  }
  .preview-title {
    font-size: 12px;
    margin-top: 7px;
    margin-bottom: 0px !important;
  }
  .text_style {
    /* white-space: nowrap; */
    width: 320px;
    font-size: 9px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2 !important;
    -webkit-box-orient: vertical;
  }
}
@media screen and (min-width: 768px) and (max-width: 1023px) {
  .qr_position {
    width: 65px;
    height: 60px;
    position: absolute;
    bottom: 15px;
    right: 0px;
    margin-right: 3.5rem;
  }
  .bgcenter[data-v-c82be23e] {
    background: url(/img/maintenance_bg.e32ce434.svg) center / contain;
    width: 550px;
    height: 100%;
    padding: 0px;
    overflow: hidden !important;
    background-repeat: no-repeat;
    margin-left: 2.5rem;
  }
  .bgpreview {
    background: url("~@/assets/imgs/leavesBg.png") center/cover;
    background-size: cover;
    object-fit: contain;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
@media screen and (min-width: 1440px) and (max-width: 2559px) {
  .seedLogo-size {
    width: 95px;
    height: 95px;
    margin-top: -0.3rem;
  }
  .icon-size {
    margin-top: 5px;
    max-width: 18px;
    max-height: 18px;
  }
  .icon-size-line {
    max-width: 25px;
    max-height: 25px;
  }
  .preview-title {
    font-size: 14px;
    margin-top: 7px;
    margin-bottom: 0px !important;
  }
  .text_style {
    width: 370px;
    font-size: 11px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2 !important;
    -webkit-box-orient: vertical;
  }
  .qr_position {
    width: 50px;
    height: 45px;
    position: absolute;
    bottom: 30px;
    right: 45px;
  }
}
@media screen and (min-width: 2560px) {
  .bgcenter[data-v-c82be23e] {
    background: url(/img/maintenance_bg.e32ce434.svg) center / contain;
    width: 600px;
    height: 96%;
    padding: 0px;
    overflow: hidden !important;
    background-repeat: no-repeat;
    margin-left: 3rem;
  }
  .bgpreview[data-v-c82be23e] {
    background: url(/img/leavesBg.d9a80949.png) center / cover;
    background-size: cover;
    -o-object-fit: contain;
    object-fit: contain;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .qr_position {
    width: 65px;
    height: 55px;
    position: absolute;
    bottom: 12px;
    right: 80px;
  }
}
@media screen and (min-width: 1150px) and (max-width: 1263px) {
  .qr_position {
    width: 50px;
    height: 45px;
    position: absolute;
    bottom: 35px;
    right: 47px;
  }
}
@media screen and (min-width: 1024px) and (max-width: 1150px) {
  .qr_position {
    width: 50px;
    height: 45px;
    position: absolute;
    bottom: 65px;
    right: 45px;
  }
}
@media screen and (max-width: 700px) {
  .bgcenter[data-v-c82be23e] {
    background: url(/img/maintenance_bg.e32ce434.svg) center / contain;
    width: 470px;
    height: 100%;
    padding: 0px;
    overflow: hidden !important;
    background-repeat: no-repeat;
    margin-left: 2.5rem;
  }
  .bgpreview {
    background: url("~@/assets/imgs/leavesBg.png") center/cover;
    background-size: cover;
    object-fit: contain;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .qr_position[data-v-c82be23e] {
    width: 55px;
    height: 50px;
    position: absolute;
    bottom: 40px;
    right: 0px;
    margin-right: 3.5rem;
  }
  .seedLogo-size {
    width: 80px;
    height: 80px;
    margin-top: -0.3rem;
  }
}
</style>
